<template>
    <div id="auth">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: "Auth",
};
</script>

<style lang="scss">
    #auth {
        background-image: url("https://images.wallpaperscraft.com/image/book_clock_bookmark_mood_67426_1920x1080.jpg") !important;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>